import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";
import { PaymentTableExportIcon } from "../../../../../assets/icons/MUI/PaymentIcons";

const TableHeading = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "20px 16px",
        borderBottom: "1px solid #EAECF0",
      }}
    >
      <Typography
        sx={{
          color: "var(--Dark---1000, #111)",
          fontFamily: "Montserrat",
          fontSize: "18px",
          fontStyle: "normal",
          fontWeight: 600,
          lineHeight: "28px",
          display: "flex",
          gap: "8px",
          alignItems: "center",
        }}
      >
        {t("pages.payment.paymentLinks.totalPayment")}
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
      >
        <Button
          disabled
          variant="outlined-md"
          startIcon={<PaymentTableExportIcon />}
          sx={{
            borderRadius: "8px",
            border: "1px solid var(--Gray-300, #D0D5DD) !important",
            background: "var(--Base-White, #FFF) !important",
            boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
            color: "var(--Gray-700, #344054)",
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          {t("pages.payment.paymentLinks.export")}
        </Button>
      </Box>
    </Box>
  );
};

export default TableHeading;
